import React from 'react';
import styled from 'styled-components';

const Div = styled.div`
  width: 100%;
  height: 1080px;
`;

export const Wrap = (props) => {
  return (
    <Div>{props.children}</Div>
  );
};